// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/animations.css';
import reportWebVitals from './reportWebVitals';
import { CartProvider } from './context/CartContext';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initGlobalHaptics } from './utils/haptics';

initGlobalHaptics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CartProvider>
      <App />
    </CartProvider>
  </React.StrictMode>
);

// Unregister service worker to prevent caching issues
serviceWorkerRegistration.unregister();

// Actively bust cache for users who already have the old service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    let hasUnregistered = false;
    for (let registration of registrations) {
      registration.unregister();
      hasUnregistered = true;
    }
    if (hasUnregistered) {
      // Clear all caches
      if ('caches' in window) {
        caches.keys().then((names) => {
          for (let name of names) caches.delete(name);
        });
      }
      // Force reload to get the fresh app without an infinite loop
      // (because next load will have no registrations)
      window.location.reload();
    }
  });
}

reportWebVitals();


